// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3NMdT","label":"Section_label__w2keZ","contentWrap":"Section_contentWrap__1TEY6","footer":"Section_footer__1uVlZ","footerInner":"Section_footerInner__3VRAM"};